



















import { Component, Vue } from 'vue-property-decorator'
import VModal from '@/components/VModal.vue'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import { Action } from 'vuex-class'
import * as types from '@/store/account/types'
import ValidatedForm from '@/utilities/validation/validatedform'
import FormField from '@/utilities/validation/formfield'
import passwordValidator from '@/utilities/validators/password'

@Component({ components: { VButton, VInput, VModal } })
export default class Verify extends Vue {
  @Action('changePassword', { namespace: 'account' }) changePassword!: types.ChangePasswordAction
  private changed = false
  private changing = false
  private error = false
  private ua = (this as any).$ua

  private password = new FormField(passwordValidator, '');
  private passwordForm = new ValidatedForm({
    password: this.password,
    repeatPassword: new FormField((value) => value === this.password.value ? [] : ['Wachtwoorden komen niet overeen'], '')
  })

  private submit () {
    if (this.passwordForm.validateForm()) {
      this.changing = true
      this.changePassword({
        token: this.$route.params.token,
        uidb64: this.$route.params.uidb64,
        newPassword: this.passwordForm.fields.password.value
      }).then(() => {
        this.changed = true
        this.ua.trackEvent('account', 'password-reset-success', true)
      }).catch(() => {
        this.error = true
        this.ua.trackEvent('account', 'password-reset-failed', true)
      }).finally(() => {
        this.changing = false
      })
    }
  }
}
